import { render } from "./ManagerSelectionModal.vue?vue&type=template&id=48e33d96&scoped=true"
import script from "./ManagerSelectionModal.vue?vue&type=script&lang=js"
export * from "./ManagerSelectionModal.vue?vue&type=script&lang=js"

import "./ManagerSelectionModal.vue?vue&type=style&index=0&id=48e33d96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e33d96"]])

export default __exports__